/**
 * Different Date range types supported in mini
 */
export enum MiniDateRangeType {
    Day = 0,
    Week = 1,
    Month = 2,
    WorkWeek = 3,
    Agenda = 4,
}
